import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBoxArchiveLight = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M4 20.0805C4.31034 20.4943 6.58621 19.977 5.96552 20.3908C5.44907 20.7351 6.58621 20.3908 7 20.1839C7.41379 19.977 7.31034 20.5977 7.72414 20.1839C8.13793 19.7701 8.34483 20.1839 8.55172 20.1839C8.71724 20.1839 9.27586 19.8736 10 20.0805",
			stroke: "white",
			strokeWidth: .2,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "path-2-inside-1_4723_517",
			fill: "white",
			children: /* @__PURE__ */ _jsx("path", { d: "M23 20C23 22.2091 21.2091 24 19 24H5C2.79086 24 1 22.2091 1 20V8.72949C1.29446 8.90012 1.63519 9 2 9H22C22.3648 9 22.7055 8.90012 23 8.72949V20Z" })
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23 20C23 22.2091 21.2091 24 19 24H5C2.79086 24 1 22.2091 1 20V8.72949C1.29446 8.90012 1.63519 9 2 9H22C22.3648 9 22.7055 8.90012 23 8.72949V20Z",
			fill: "url(#paint0_linear_4723_517)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19 24V24.4V24.4V24ZM5 24V24.4V24.4V24ZM1 8.72949L1.20055 8.3834L0.6 8.03541V8.72949H1ZM22 9V9.4V9.4V9ZM23 8.72949H23.4V8.03541L22.7995 8.3834L23 8.72949ZM23 20H22.6C22.6 21.9882 20.9882 23.6 19 23.6V24V24.4C21.4301 24.4 23.4 22.4301 23.4 20H23ZM19 24V23.6H5V24V24.4H19V24ZM5 24V23.6C3.01178 23.6 1.4 21.9882 1.4 20H1H0.6C0.6 22.4301 2.56995 24.4 5 24.4V24ZM1 20H1.4V8.72949H1H0.6V20H1ZM1 8.72949L0.799454 9.07559C1.15149 9.27958 1.56097 9.4 2 9.4V9V8.6C1.7094 8.6 1.43743 8.52066 1.20055 8.3834L1 8.72949ZM2 9V9.4H22V9V8.6H2V9ZM22 9V9.4C22.439 9.4 22.8485 9.27958 23.2005 9.07559L23 8.72949L22.7995 8.3834C22.5626 8.52066 22.2906 8.6 22 8.6V9ZM23 8.72949H22.6V20H23H23.4V8.72949H23Z",
			fill: "url(#paint1_linear_4723_517)",
			mask: "url(#path-2-inside-1_4723_517)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4 18.0805C4.31034 18.4943 6.58621 17.977 5.96552 18.3908C5.44907 18.7351 6.58621 18.3908 7 18.1839C7.41379 17.977 7.31034 18.5977 7.72414 18.1839C8.13793 17.7701 8.34483 18.1839 8.55172 18.1839C8.71724 18.1839 9.27586 17.8736 10 18.0805",
			stroke: "#B45309",
			strokeWidth: .2,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 10.25,
			y: 11.25,
			width: 3.5,
			height: .5,
			rx: .25,
			stroke: "#B45309",
			strokeWidth: .5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15 18H20",
			stroke: "#B45309",
			strokeWidth: .2,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12 19H20",
			stroke: "#B45309",
			strokeWidth: .2,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13 20H20",
			stroke: "#B45309",
			strokeWidth: .2,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: .2,
			y: 3.2,
			width: 23.6,
			height: 5.6,
			rx: 1.8,
			fill: "url(#paint2_linear_4723_517)",
			stroke: "url(#paint3_linear_4723_517)",
			strokeWidth: .4
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1 8.72949C1.29446 8.90012 1.63519 9 2 9H22C22.3648 9 22.7055 8.90012 23 8.72949V9.72949C22.7055 9.90012 22.3648 10 22 10H2C1.63519 10 1.29446 9.90012 1 9.72949V8.72949Z",
			fill: "url(#paint4_linear_4723_517)"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_4723_517",
				x1: 12,
				y1: 8.06556,
				x2: 12,
				y2: 24,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", {
					stopColor: "#D97706",
					stopOpacity: .24
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#D97706"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_4723_517",
				x1: 12,
				y1: 8.06556,
				x2: 12,
				y2: 24,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", {
					stopColor: "#D97706",
					stopOpacity: 0
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#D97706"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint2_linear_4723_517",
				x1: 1.80221,
				y1: 3.39451,
				x2: 3.35173,
				y2: 12.3757,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", {
					stopColor: "#FFCC6E",
					stopOpacity: .4
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#FFCC6E"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint3_linear_4723_517",
				x1: 22.5,
				y1: 9,
				x2: 7.5,
				y2: 3,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", {
					stopColor: "#733F03",
					stopOpacity: .04
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#733F03",
					stopOpacity: .04
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint4_linear_4723_517",
				x1: 2.65202,
				y1: 7.62606,
				x2: 2.96226,
				y2: 11.5181,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", {
					stopColor: "#D97706",
					stopOpacity: .4
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#FFBB3D"
				})]
			})
		] })
	]
});
export default SvgBoxArchiveLight;
